import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { paySlipNotAvaible } from "../../../../Icons/Icons";
import { DatePicker } from "antd";
import dayjs from "dayjs";
// import { useViewEmployeePaySlipDetails } from "../../../../queries/payrollQuries";
import { useNavigate } from "react-router-dom";

const Payslip = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const month = selectedDate.month() + 1;
  const year = selectedDate.year();
  // const { data } = useViewEmployeePaySlipDetails({ month, year });
  // const payslipData = data?.data || [];
  // const netPay = payslipData.find((item) => item.component_name === "Net Pay")
  //   ?.calculated_value;

  const navigate = useNavigate();

  const handleMonthChange = (date) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  const disableFutureMonths = (current) => {
    return current && current > dayjs().endOf("month");
  };

  const formatAmount = (val) =>
    `₹ ${Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

  return (
    <div className="border rounded-md p-5 h-full w-full">
      <div className="flex justify-between font-medium">
        <p>Pay Slip</p>
        <p className="flex items-center gap-2">
          {isCalendarOpen ? (
            <DatePicker
              picker="month"
              value={selectedDate}
              onChange={handleMonthChange}
              format="MMMM YYYY"
              disabledDate={disableFutureMonths}
            />
          ) : (
            selectedDate.format("MMMM YYYY")
          )}
          <i
            className="ico-down text-blue-600 cursor-pointer"
            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
          />
        </p>
      </div>
    <div className="flex flex-col items-center py-6">
          <span className="text-5xl mb-3">{paySlipNotAvaible}</span>
          <p className="text-center text-gray-400">Payslip not available yet</p>
        </div>
      {/* {payslipData.length > 0 ? (
        <div className="flex flex-col items-center py-6">
          <p className="text-gray-500 text-sm mb-2">Net Pay</p>
          <h3 className="text-lg font-bold text-green-700 mb-4">
            {formatAmount(netPay)}
          </h3>
          <button
            onClick={() =>
              navigate(`/payroll/my-payroll/payslip?month=${month}&year=${year}`)
            }
            className="btn btn-sm bg-blue-600 text-white px-4 py-1 rounded"
          >
            View Payslip
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center py-6">
          <span className="text-5xl mb-3">{paySlipNotAvaible}</span>
          <p className="text-center text-gray-400">Payslip not available yet</p>
        </div>
      )} */}
    </div>
  );
};

export default Payslip;
